import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32259e7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option-item-label" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选项设置", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增选项")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" = ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Rank = _resolveComponent("Rank")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_vue_draggable_next = _resolveComponent("vue-draggable-next")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form_item, { label: "提示文字" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx._placeholder,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._placeholder) = $event)),
          size: "default",
          placeholder: "请设置提示语"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form, { "label-position": "top" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "选项设置",
          class: "options"
        }, {
          label: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_button, {
                icon: "Plus",
                type: "default",
                size: "default",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add()))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_vue_draggable_next, {
              list: _ctx._value.options,
              group: "option",
              handler: ".el-icon-rank",
              options: _ctx.dragOption
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._value.options, (op, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "option-item"
                  }, [
                    _createVNode(_component_el_icon, {
                      class: "el-icon-rank",
                      size: "1em"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Rank)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx._value.options[index].value,
                      "onUpdate:modelValue": ($event: any) => ((_ctx._value.options[index].value) = $event),
                      style: {"width":"40%"},
                      placeholder: "选项值",
                      clearable: ""
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          icon: "Delete",
                          type: "danger",
                          size: "default",
                          onClick: ($event: any) => (_ctx.del(index))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx._value.options[index].name,
                      "onUpdate:modelValue": ($event: any) => ((_ctx._value.options[index].name) = $event),
                      style: {"width":"50%"},
                      placeholder: "选项标题",
                      clearable: ""
                    }, {
                      append: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["list", "options"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "选项展开" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_switch, {
          modelValue: _ctx._value.expanding,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._value.expanding) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}